/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function InfoBlueIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 16 16'
      {...props}
    >
      <mask
        id='info-blue_svg__a'
        width={16}
        height={16}
        x={0}
        y={0}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill='#D9D9D9' d='M0 0h16v16H0z' />
      </mask>
      <g mask='url(#info-blue_svg__a)'>
        <path
          fill='#007AFC'
          d='M7.333 11.333h1.334v-4H7.333zM8 6a.65.65 0 0 0 .475-.192.65.65 0 0 0 .192-.475.65.65 0 0 0-.192-.475A.65.65 0 0 0 8 4.667a.65.65 0 0 0-.475.191.65.65 0 0 0-.192.475q0 .285.192.475A.65.65 0 0 0 8 6m0 8.667a6.5 6.5 0 0 1-2.6-.525 6.7 6.7 0 0 1-2.117-1.425A6.7 6.7 0 0 1 1.858 10.6 6.5 6.5 0 0 1 1.333 8q0-1.383.525-2.6a6.7 6.7 0 0 1 1.425-2.117q.9-.9 2.117-1.425A6.5 6.5 0 0 1 8 1.333q1.383 0 2.6.525t2.117 1.425T14.142 5.4t.525 2.6-.525 2.6a6.7 6.7 0 0 1-1.425 2.117q-.9.9-2.117 1.425a6.5 6.5 0 0 1-2.6.525'
        />
      </g>
    </svg>
  )
}
